<p class="card-text">Ensure quality through comprehensive testing and process improvements.</p>
<ul>
    <li>Expertise in manual and automated testing</li>
    <li>Experience with Selenium or similar tools</li>
    <li>Experience with JUnit Tests</li>
</ul>
